export default {
    setRecruitmentDepthChart(state, recruitmentDepthChart) {
        state.recruitmentDepthChart = recruitmentDepthChart;
    },
    setError(state, error) {
        state.error = error.toString();
    },
};
